import { subMonths } from "date-fns";
import { useFormContext } from "react-hook-form";
import format from "lib/format";
import CalendarField from "./CalendarField";

type FormValues = {
  startDate: string;
  endDate: string;
};

const DateRangeField = () => {
  const { setValue } = useFormContext<FormValues>();

  const handleDateChange = (month: number) => {
    setValue("startDate", format(subMonths(new Date(), month), "yyyy-MM-dd"));
    setValue("endDate", format(new Date(), "yyyy-MM-dd"));
  };

  return (
    <div className="w-full flex gap-[0.313rem]">
      <div className="flex items-center gap-[0.313rem] flex-1">
        <CalendarField
          name="startDate"
          defaultValue={format(subMonths(new Date(), 1), "yyyy-MM-dd")}
        />
        <span>~</span>
        <CalendarField
          name="endDate"
          defaultValue={format(new Date(), "yyyy-MM-dd")}
        />
      </div>
      <ul className="flex gap-[0.313rem]">
        <li>
          <button
            onClick={() => handleDateChange(1)}
            type="button"
            className="h-9 w-[3.313rem] inline-flex justify-center items-center rounded-md border border-secondary text-14 text-secondary bg-white"
          >
            1개월
          </button>
        </li>
        <li>
          <button
            onClick={() => handleDateChange(3)}
            type="button"
            className="h-9 w-[3.313rem] inline-flex justify-center items-center rounded-md border border-secondary text-14 text-secondary bg-white"
          >
            3개월
          </button>
        </li>
        <li>
          <button
            onClick={() => handleDateChange(6)}
            type="button"
            className="h-9 w-[3.313rem] inline-flex justify-center items-center rounded-md border border-secondary text-14 text-secondary bg-white"
          >
            6개월
          </button>
        </li>
      </ul>
    </div>
  );
};

export default DateRangeField;
